var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVendorManagementNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_811_6756)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.61438 14.0143V20.0571C4.61438 20.2352 4.68512 20.406 4.81104 20.532C4.93695 20.6578 5.10773 20.7286 5.28581 20.7286H18.7144C18.8924 20.7286 19.0633 20.6578 19.1892 20.532C19.315 20.406 19.3858 20.2352 19.3858 20.0571V14.0143",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3429 14.0143V20.7286",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.61438 16.0286H13.343",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.27148 7.97142L5.28577 3.27142H18.7143L20.7286 7.97142H3.27148Z",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.01891 7.97144V9.31429C9.01891 10.0266 8.73596 10.7097 8.23228 11.2134C7.72862 11.7171 7.04549 12 6.3332 12H5.9572C5.24491 12 4.56178 11.7171 4.05812 11.2134C3.55444 10.7097 3.27148 10.0266 3.27148 9.31429V7.97144",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0215 7.97144V9.31429C15.0215 10.0266 14.7385 10.7097 14.2349 11.2134C13.7312 11.7171 13.0481 12 12.3358 12H11.6644C10.9521 12 10.2689 11.7171 9.76527 11.2134C9.26159 10.7097 8.97864 10.0266 8.97864 9.31429V7.97144",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7286 7.97144V9.31429C20.7286 10.0266 20.4457 10.7097 19.942 11.2134C19.4383 11.7171 18.7552 12 18.0429 12H17.7072C16.9949 12 16.3118 11.7171 15.8081 11.2134C15.3044 10.7097 15.0215 10.0266 15.0215 9.31429V7.97144",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_811_6756"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(2 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVendorManagementNew);
export default __webpack_public_path__ + "static/media/VendorManagementNew.1d306b0a806a1cfe0e2a5c49033a2c25.svg";
export { ForwardRef as ReactComponent };